import cn from 'classnames';
import styles from './defaultIconStyles.module.scss';

export interface IIcon {
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  onMouseDown?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  size?: 16 | 20 | 32 | 'inherit';
}

export const useIconProps = (props?: IIcon & { ref: React.ForwardedRef<unknown> }) => {
  return {
    className: cn(props?.className, {
      [styles.root]: true,
      [styles.size16]: props?.size === 16,
      [styles.size20]: props?.size === 20,
      [styles.size32]: props?.size === 32,
      [styles.inherit]: props?.size === 'inherit',
    }),
    ref: props?.ref as React.LegacyRef<SVGSVGElement>,
    onClick: props?.onClick,
    onMouseDown: props?.onMouseDown,
    style: props?.style,
  };
};
